module.exports = __webpack_public_path__ + "img/9791130606293.7ab6dc89.jpg";